<div class="customers-page">

  <h1>👥 {{ t('customerManagement') }}</h1>

  <div
    class="customer-card"
    *ngFor="let c of customers">

    <h2>{{ c.email }}</h2>

    <p><b>{{ t('customerId') }}:</b> {{ c.id }}</p>

    <p><b>{{ t('emailLabel') }}:</b> {{ c.email }}</p>

    <p><b>{{ t('roleLabel') }}:</b> {{ c.role }}</p>

    <p>
      <b>{{ t('statusLabel') }}:</b>

      <span
        [style.color]="
          c.blocked
            ? 'red'
            : 'green'
        ">

        {{ c.blocked
            ? t('blocked')
            : t('active') }}

      </span>

    </p>

    <div class="actions">

      <button
        class="block-btn"
        (click)="toggleBlock(c)">

        {{ c.blocked
            ? t('unblock')
            : t('block') }}

      </button>

      <button
        class="delete-btn"
        (click)="deleteCustomer(c.id)">

        {{ t('delete') }}

      </button>

    </div>

  </div>

</div>